import { ReactNode } from 'react';
import { Box } from '@nimbus-ds/components';
import { ExclamationTriangleIcon } from '@nimbus-ds/icons';
import { EmptyMessage, InteractiveList } from '@nimbus-ds/patterns';

interface GenericSelectionModalListProps {
  items: ReactNode[];
  selectAllCheckbox: ReactNode;
  showEmptyMessage: boolean;
  emptyTitle: string;
  emptyMessage: string;
}

function GenericSelectionModalList({
  items,
  selectAllCheckbox,
  showEmptyMessage,
  emptyTitle,
  emptyMessage,
}: Readonly<GenericSelectionModalListProps>): JSX.Element {
  if (showEmptyMessage) {
    return (
      <EmptyMessage
        title={emptyTitle}
        text={emptyMessage}
        icon={<ExclamationTriangleIcon size="large" />}
      />
    );
  }

  return (
    <Box flex="1" overflow="auto" height="100%">
      <InteractiveList>
        {selectAllCheckbox}
        {items}
      </InteractiveList>
    </Box>
  );
}

export default GenericSelectionModalList;
